import { S25Util } from "../../util/s25-util";
import type { IngestionFieldDefinition } from "./data.ingestion.service";

/** Search-criteria / dropdown shape: `itemTypeId` is the atrb data-type character (`R`, `S`, …). */
export type CustAtrbSearchItem = {
    itemId?: number;
    itemTypeId?: string | number;
    multiVal?: boolean;
    multi_val?: boolean;
};

export function stampCustAtrbFromSearchItem(
    fieldDef: IngestionFieldDefinition,
    item: CustAtrbSearchItem | undefined | null,
): void {
    if (item?.itemId == null) {
        fieldDef.custAtrbId = undefined;
        fieldDef.custAtrb = undefined;
        return;
    }
    fieldDef.custAtrbId = item.itemId;
    const atrbDataType = item.itemTypeId != null ? String(item.itemTypeId) : undefined;
    if (!atrbDataType) {
        console.warn(`Invalid atrbDataType for item ${item.itemId}: [${atrbDataType}]`);
        fieldDef.custAtrb = undefined;
        return;
    }
    fieldDef.custAtrb = {
        atrbDataType,
        multiVal: S25Util.toBool(item.multiVal ?? item.multi_val) || undefined,
    };
}

export function stampMissingCustAtrbFromSearchItems(
    fieldDefs: IngestionFieldDefinition[],
    items: CustAtrbSearchItem[],
): void {
    const itemIdToItem = new Map<number, CustAtrbSearchItem>();
    for (const item of items) {
        if (item.itemId != null) {
            itemIdToItem.set(item.itemId, item);
        }
    }
    for (const fieldDef of fieldDefs) {
        if (fieldDef.custAtrbId == null || fieldDef.custAtrb?.atrbDataType) {
            continue;
        }
        const item = itemIdToItem.get(fieldDef.custAtrbId);
        if (item) {
            stampCustAtrbFromSearchItem(fieldDef, item);
        }
    }
}
